import CoatsSelector from './CoatsSelector'

export * from './CoatsSelector'
export default CoatsSelector
